/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CustomerDepartmentAddRequirementsRequest } from '../models/customer-department-add-requirements-request';
import { CustomerDepartmentUpdateRequirementsRequest } from '../models/customer-department-update-requirements-request';
import { EmptySuccessfulResponse } from '../models/empty-successful-response';

@Injectable({
  providedIn: 'root',
})
export class CustomerLocationDepartmentRequirementService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation putCustomerLocationDepartmentRequirementUpdate
   */
  static readonly PutCustomerLocationDepartmentRequirementUpdatePath = '/api/web/v1/customers/{customer}/locations/{location}/departments/{department}/requirements';

  /**
   * Update Customer Location Department Requirements.
   *
   * **Accessible only for users with permission 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putCustomerLocationDepartmentRequirementUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putCustomerLocationDepartmentRequirementUpdate$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Department Id.
     */
    department: number;
    context?: HttpContext
    body: CustomerDepartmentUpdateRequirementsRequest
  }
): Observable<StrictHttpResponse<EmptySuccessfulResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerLocationDepartmentRequirementService.PutCustomerLocationDepartmentRequirementUpdatePath, 'put');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('location', params.location, {});
      rb.path('department', params.department, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptySuccessfulResponse>;
      })
    );
  }

  /**
   * Update Customer Location Department Requirements.
   *
   * **Accessible only for users with permission 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putCustomerLocationDepartmentRequirementUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putCustomerLocationDepartmentRequirementUpdate(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Department Id.
     */
    department: number;
    context?: HttpContext
    body: CustomerDepartmentUpdateRequirementsRequest
  }
): Observable<EmptySuccessfulResponse> {

    return this.putCustomerLocationDepartmentRequirementUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<EmptySuccessfulResponse>) => r.body as EmptySuccessfulResponse)
    );
  }

  /**
   * Path part for operation patchCustomerLocationDepartmentRequirementAdd
   */
  static readonly PatchCustomerLocationDepartmentRequirementAddPath = '/api/web/v1/customers/{customer}/locations/{location}/departments/{department}/requirements';

  /**
   * Add Requirements to Customer Location Department.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchCustomerLocationDepartmentRequirementAdd()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchCustomerLocationDepartmentRequirementAdd$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Department Id.
     */
    department: number;
    context?: HttpContext
    body: CustomerDepartmentAddRequirementsRequest
  }
): Observable<StrictHttpResponse<EmptySuccessfulResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerLocationDepartmentRequirementService.PatchCustomerLocationDepartmentRequirementAddPath, 'patch');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('location', params.location, {});
      rb.path('department', params.department, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptySuccessfulResponse>;
      })
    );
  }

  /**
   * Add Requirements to Customer Location Department.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchCustomerLocationDepartmentRequirementAdd$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchCustomerLocationDepartmentRequirementAdd(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Department Id.
     */
    department: number;
    context?: HttpContext
    body: CustomerDepartmentAddRequirementsRequest
  }
): Observable<EmptySuccessfulResponse> {

    return this.patchCustomerLocationDepartmentRequirementAdd$Response(params).pipe(
      map((r: StrictHttpResponse<EmptySuccessfulResponse>) => r.body as EmptySuccessfulResponse)
    );
  }

  /**
   * Path part for operation deleteCustomerLocationDepartmentRequirementDelete
   */
  static readonly DeleteCustomerLocationDepartmentRequirementDeletePath = '/api/web/v1/customers/{customer}/locations/{location}/departments/{department}/requirements/{requirement}';

  /**
   * Delete Requirement from the Customer Location Department.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCustomerLocationDepartmentRequirementDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomerLocationDepartmentRequirementDelete$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Department Id.
     */
    department: number;

    /**
     * Requirement Id.
     */
    requirement: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<EmptySuccessfulResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerLocationDepartmentRequirementService.DeleteCustomerLocationDepartmentRequirementDeletePath, 'delete');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('location', params.location, {});
      rb.path('department', params.department, {});
      rb.path('requirement', params.requirement, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptySuccessfulResponse>;
      })
    );
  }

  /**
   * Delete Requirement from the Customer Location Department.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteCustomerLocationDepartmentRequirementDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomerLocationDepartmentRequirementDelete(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Department Id.
     */
    department: number;

    /**
     * Requirement Id.
     */
    requirement: number;
    context?: HttpContext
  }
): Observable<EmptySuccessfulResponse> {

    return this.deleteCustomerLocationDepartmentRequirementDelete$Response(params).pipe(
      map((r: StrictHttpResponse<EmptySuccessfulResponse>) => r.body as EmptySuccessfulResponse)
    );
  }

}
